import AlertsAgGrid from './alertsAgGrid';

export default AlertsAgGrid;